import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {TeardownDirectorySyncForInstance as TeardownDirectorySyncForInstanceMutation} from 'nutshell-graphql-types';

import TEARDOWN_DIRECTORY_SYNC_FOR_INSTANCE from '../mutations/teardown-directory-sync.graphql';

export const useTeardownDirectorySyncForInstance = (): {
    teardownDirectorySyncForInstance: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [teardownDirectorySyncForInstance, {loading, error}] = useMutation<
        TeardownDirectorySyncForInstanceMutation,
        Record<any, any>
    >(TEARDOWN_DIRECTORY_SYNC_FOR_INSTANCE);

    return {
        teardownDirectorySyncForInstance: () => teardownDirectorySyncForInstance({}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
